import { VariableValue } from '@components/Variables/types'

import { GETAllVariables } from '@types'

import { isNotEmpty } from './isNotEmpty'

export const getValuesFromVariables = (
  variables: VariableValue[] | undefined | GETAllVariables
): Record<string, string> => {
  if (!variables) return {}

  return variables.reduce((acc, variable) => {
    if (isNotEmpty(variable?.value) && isNotEmpty(variable.defaultValue)) return acc

    acc[variable.internalId] = variable.value ?? variable.defaultValue ?? ''

    return acc
  }, {} as Record<string, string>)
}
